<div class="form-error" *ngIf="control.touched || control.dirty">
  <mat-error *ngFor="let message of messages">
    <span [innerHTML]="message"></span>
  </mat-error>
</div>